import axios from "axios";

export const getListRecommendCentre = async (postcode) => {
    return new Promise(async (resolve, reject) => {
        axios
            .get(`/enquiry/recommendcentre?postcode=${postcode}`)
            .then(
                (response) => {
                    resolve(response?.data);
                },
                (err) => {
                    reject(err);
                }
            )
            .catch((error) => {
                reject(error);
            });
    });
};

export const getTourAvailabilities = (startDate, endDate, token) => {
    let data = {
        token: token,
        startDate: startDate,
        endDate: endDate
    }
    let headers = {
        'Content-Type': 'application/json',
    }
    let url = '/enquiry/getlivetouravailabilities';
    const json = JSON.stringify(data)
    return axios
        .post(url, json, { headers: headers })
}